module.exports = __webpack_public_path__ + "static/img/2_2_1_2.390c7550.jpg";